module.exports = __webpack_public_path__ + "img/veloster-donator.766427ae.png";